import { EnumGtagEvents } from 'constants/enums';
import analyticsManager from '../tagManager/manager';

export default function missproductsViewAnalitic() {
  analyticsManager.gtag(EnumGtagEvents.VIEW_MISSING_PRODUCTS);
}
